/** API paths for the Descope service Management APIs */
export default {
  user: {
    create: '/v1/mgmt/user/create',
    createTestUser: '/v1/mgmt/user/create/test',
    createBatch: '/v1/mgmt/user/create/batch',
    update: '/v1/mgmt/user/update',
    patch: '/v1/mgmt/user/patch',
    patchBatch: '/v1/mgmt/user/patch/batch',
    delete: '/v1/mgmt/user/delete',
    deleteBatch: '/v1/mgmt/user/delete/batch',
    deleteAllTestUsers: '/v1/mgmt/user/test/delete/all',
    load: '/v1/mgmt/user',
    logout: '/v1/mgmt/user/logout',
    loadUsers: '/v1/mgmt/users/load',
    search: '/v2/mgmt/user/search',
    searchTestUsers: '/v2/mgmt/user/search/test',
    getProviderToken: '/v1/mgmt/user/provider/token',
    updateStatus: '/v1/mgmt/user/update/status',
    updateLoginId: '/v1/mgmt/user/update/loginid',
    updateEmail: '/v1/mgmt/user/update/email',
    updatePhone: '/v1/mgmt/user/update/phone',
    updateDisplayName: '/v1/mgmt/user/update/name',
    updatePicture: '/v1/mgmt/user/update/picture',
    updateCustomAttribute: '/v1/mgmt/user/update/customAttribute',
    setRole: '/v1/mgmt/user/update/role/set',
    addRole: '/v2/mgmt/user/update/role/add',
    removeRole: '/v1/mgmt/user/update/role/remove',
    setSSOApps: '/v1/mgmt/user/update/ssoapp/set',
    addSSOApps: '/v1/mgmt/user/update/ssoapp/add',
    removeSSOApps: '/v1/mgmt/user/update/ssoapp/remove',
    addTenant: '/v1/mgmt/user/update/tenant/add',
    removeTenant: '/v1/mgmt/user/update/tenant/remove',
    setPassword: '/v1/mgmt/user/password/set', // Deprecated
    setTemporaryPassword: '/v1/mgmt/user/password/set/temporary',
    setActivePassword: '/v1/mgmt/user/password/set/active',
    expirePassword: '/v1/mgmt/user/password/expire',
    removeAllPasskeys: '/v1/mgmt/user/passkeys/delete',
    removeTOTPSeed: '/v1/mgmt/user/totp/delete',
    removeRecoveryCodes: '/v1/mgmt/user/recovery-codes/delete',
    generateOTPForTest: '/v1/mgmt/tests/generate/otp',
    generateMagicLinkForTest: '/v1/mgmt/tests/generate/magiclink',
    generateEnchantedLinkForTest: '/v1/mgmt/tests/generate/enchantedlink',
    generateEmbeddedLink: '/v1/mgmt/user/signin/embeddedlink',
    generateSignUpEmbeddedLink: '/v1/mgmt/user/signup/embeddedlink',
    history: '/v1/mgmt/user/history',
    import: '/v1/mgmt/user/import',
    updateRecoveryEmail: '/v1/mgmt/user/update/recovery/email',
    updateRecoveryPhone: '/v1/mgmt/user/update/recovery/phone',
    updateName: '/v1/mgmt/user/update/name',
    getCustomAttributes: '/v1/mgmt/user/customattributes',
    createCustomAttributes: '/v1/mgmt/user/customattribute/create',
    deleteCustomAttributes: '/v1/mgmt/user/customattribute/delete',
    removePasskey: '/v1/mgmt/user/passkey/delete',
    listPasskeys: '/v1/mgmt/user/passkeys/list',
    listTrustedDevices: '/v1/mgmt/user/trusteddevices/list',
    removeTrustedDevices: '/v1/mgmt/user/trusteddevices/remove',
  },
  project: {
    updateName: '/v1/mgmt/project/update/name',
    updateTags: '/v1/mgmt/project/update/tags',
    clone: '/v1/mgmt/project/clone',
    projectsList: '/v1/mgmt/projects/list',
    exportSnapshot: '/v1/mgmt/project/snapshot/export',
    importSnapshot: '/v1/mgmt/project/snapshot/import',
    validateSnapshot: '/v1/mgmt/project/snapshot/validate',
    delete: '/v1/mgmt/project/delete',
  },
  accessKey: {
    create: '/v1/mgmt/accesskey/create',
    load: '/v1/mgmt/accesskey',
    search: '/v1/mgmt/accesskey/search',
    update: '/v1/mgmt/accesskey/update',
    deactivate: '/v1/mgmt/accesskey/deactivate',
    deactivateBatch: '/v1/mgmt/accesskey/deactivate/batch',
    activate: '/v1/mgmt/accesskey/activate',
    activateBatch: '/v1/mgmt/accesskey/activate/batch',
    delete: '/v1/mgmt/accesskey/delete',
    deleteBatch: '/v1/mgmt/accesskey/delete/batch',
    rotate: '/v1/mgmt/accesskey/rotate',
  },
  tenant: {
    create: '/v1/mgmt/tenant/create',
    update: '/v1/mgmt/tenant/update',
    delete: '/v1/mgmt/tenant/delete',
    load: '/v1/mgmt/tenant',
    settings: '/v1/mgmt/tenant/settings',
    loadAll: '/v1/mgmt/tenant/all',
    searchAll: '/v1/mgmt/tenant/search',
    updateDefaultRoles: '/v1/mgmt/tenant/updateDefaultRoles',
    generateSSOConfigurationLink: '/v2/mgmt/tenant/adminlinks/sso/generate',
    revokeSSOConfigurationLink: '/v1/mgmt/tenant/adminlinks/sso/revoke',
  },
  ssoApplication: {
    oidcCreate: '/v1/mgmt/sso/idp/app/oidc/create',
    samlCreate: '/v1/mgmt/sso/idp/app/saml/create',
    oidcUpdate: '/v1/mgmt/sso/idp/app/oidc/update',
    samlUpdate: '/v1/mgmt/sso/idp/app/saml/update',
    wsfedCreate: '/v1/mgmt/sso/idp/app/wsfed/create',
    wsfedUpdate: '/v1/mgmt/sso/idp/app/wsfed/update',
    delete: '/v1/mgmt/sso/idp/app/delete',
    load: '/v1/mgmt/sso/idp/app/load',
    loadAll: '/v1/mgmt/sso/idp/apps/load',
    secret: '/v1/mgmt/sso/idp/app/secret',
    rotate: '/v1/mgmt/sso/idp/app/rotate',
  },
  inboundApplication: {
    create: '/v1/mgmt/thirdparty/app/create',
    update: '/v1/mgmt/thirdparty/app/update',
    patch: '/v1/mgmt/thirdparty/app/patch',
    delete: '/v1/mgmt/thirdparty/app/delete',
    load: '/v1/mgmt/thirdparty/app/load',
    loadAll: '/v1/mgmt/thirdparty/apps/load',
    secret: '/v1/mgmt/thirdparty/app/secret',
    rotate: '/v1/mgmt/thirdparty/app/rotate',
    deleteBatch: '/v1/mgmt/thirdparty/app/delete/batch',
  },
  inboundApplicationConsents: {
    delete: '/v1/mgmt/thirdparty/consents/delete',
    deleteTenant: '/v1/mgmt/thirdparty/consents/delete/tenant',
    search: '/v1/mgmt/thirdparty/consents/search',
  },
  outboundApplication: {
    create: '/v1/mgmt/outbound/app/create',
    createByTemplate: '/v1/mgmt/outbound/app/create/bytemplate',
    update: '/v1/mgmt/outbound/app/update',
    delete: '/v1/mgmt/outbound/app/delete',
    load: '/v1/mgmt/outbound/app',
    loadAll: '/v1/mgmt/outbound/apps',
    fetchToken: '/v1/mgmt/outbound/app/user/token/latest',
    fetchTokenByScopes: '/v1/mgmt/outbound/app/user/token',
    fetchTenantToken: '/v1/mgmt/outbound/app/tenant/token/latest',
    fetchTenantTokenByScopes: '/v1/mgmt/outbound/app/tenant/token',
    deleteUserTokens: '/v1/mgmt/outbound/user/tokens',
    deleteTokenById: '/v1/mgmt/outbound/token',
    listAppsWithUserToken: '/v1/mgmt/outbound/apps-with-user-token',
    uploadUserApiKey: '/v1/mgmt/outbound/app/user/apikey/upload',
    uploadTenantApiKey: '/v1/mgmt/outbound/app/tenant/apikey/upload',
    uploadUserToken: '/v1/mgmt/outbound/app/user/oauthtoken/upload',
    uploadTenantToken: '/v1/mgmt/outbound/app/tenant/oauthtoken/upload',
    batchUploadUserTokens: '/v1/mgmt/outbound/app/user/oauthtoken/batch/upload',
    batchUploadTenantTokens: '/v1/mgmt/outbound/app/tenant/oauthtoken/batch/upload',
  },
  sso: {
    settings: '/v1/mgmt/sso/settings',
    settingsNew: '/v1/mgmt/sso/settings/new',
    authType: '/v1/mgmt/sso/settings/authtype',
    metadata: '/v1/mgmt/sso/metadata',
    mapping: '/v1/mgmt/sso/mapping',
    settingsv2: '/v2/mgmt/sso/settings',
    settingsAllV2: '/v2/mgmt/sso/settings/all',
    redirect: '/v1/mgmt/sso/redirect',
    recalculateMappings: '/v1/mgmt/sso/recalculate-mappings',
    oidc: {
      configure: '/v1/mgmt/sso/oidc',
    },
    saml: {
      configure: '/v1/mgmt/sso/saml',
      metadata: '/v1/mgmt/sso/saml/metadata',
    },
    xaa: {
      settings: '/v1/mgmt/sso/xaa/settings',
      settingsAll: '/v1/mgmt/sso/xaa/settings/all',
    },
  },
  jwt: {
    update: '/v1/mgmt/jwt/update',
    impersonate: '/v1/mgmt/impersonate',
    impersonateStepup: '/v1/mgmt/impersonate/stepup',
    stopImpersonation: '/v1/mgmt/stop/impersonation',
    signIn: '/v1/mgmt/auth/signin',
    signUp: '/v1/mgmt/auth/signup',
    signUpOrIn: '/v1/mgmt/auth/signup-in',
    anonymous: '/v1/mgmt/auth/anonymous',
    clientAssertion: '/v1/mgmt/token/clientassertion',
  },
  password: {
    settings: '/v1/mgmt/password/settings',
  },
  permission: {
    create: '/v1/mgmt/permission/create',
    createBatch: '/v1/mgmt/permission/create/batch',
    update: '/v1/mgmt/permission/update',
    updateBatch: '/v1/mgmt/permission/update/batch',
    delete: '/v1/mgmt/permission/delete',
    deleteBatch: '/v1/mgmt/permission/delete/batch',
    loadAll: '/v1/mgmt/permission/all',
  },
  role: {
    create: '/v1/mgmt/role/create',
    createBatch: '/v1/mgmt/role/create/batch',
    update: '/v1/mgmt/role/update',
    updateBatch: '/v1/mgmt/role/update/batch',
    delete: '/v1/mgmt/role/delete',
    deleteBatch: '/v1/mgmt/role/delete/batch',
    loadAll: '/v1/mgmt/role/all',
    search: '/v1/mgmt/role/search',
  },
  flow: {
    list: '/v1/mgmt/flow/list',
    delete: '/v1/mgmt/flow/delete',
    export: '/v1/mgmt/flow/export',
    import: '/v1/mgmt/flow/import',
    run: '/v1/mgmt/flow/run',
  },
  theme: {
    export: '/v1/mgmt/theme/export',
    import: '/v1/mgmt/theme/import',
  },
  group: {
    loadAllGroups: '/v1/mgmt/group/all',
    loadAllGroupsForMember: '/v1/mgmt/group/member/all',
    loadAllGroupMembers: '/v1/mgmt/group/members',
  },
  audit: {
    search: '/v1/mgmt/audit/search',
    createEvent: '/v1/mgmt/audit/event',
    createAuditWebhook: '/v2/mgmt/connector/audit/web/set',
  },
  authz: {
    schemaSave: '/v1/mgmt/authz/schema/save',
    schemaDelete: '/v1/mgmt/authz/schema/delete',
    schemaLoad: '/v1/mgmt/authz/schema/load',
    nsSave: '/v1/mgmt/authz/ns/save',
    nsDelete: '/v1/mgmt/authz/ns/delete',
    rdSave: '/v1/mgmt/authz/rd/save',
    rdDelete: '/v1/mgmt/authz/rd/delete',
    reCreate: '/v1/mgmt/authz/re/create',
    reDelete: '/v1/mgmt/authz/re/delete',
    reDeleteResources: '/v1/mgmt/authz/re/deleteresources',
    reDeleteResourceRelationsForResources: '/v1/mgmt/authz/re/deleteresourcesrelations',
    hasRelations: '/v1/mgmt/authz/re/has',
    who: '/v1/mgmt/authz/re/who',
    resource: '/v1/mgmt/authz/re/resource',
    targets: '/v1/mgmt/authz/re/targets',
    targetAll: '/v1/mgmt/authz/re/targetall',
    targetWithRelation: '/v1/mgmt/authz/re/targetwithrelation',
    getModified: '/v1/mgmt/authz/getmodified',
  },
  fga: {
    schema: '/v1/mgmt/fga/schema',
    dryRunSchema: '/v1/mgmt/fga/schema/dryrun',
    relations: '/v1/mgmt/fga/relations',
    deleteRelations: '/v1/mgmt/fga/relations/delete',
    check: '/v1/mgmt/fga/check',
    resourcesLoad: '/v1/mgmt/fga/resources/load',
    resourcesSave: '/v1/mgmt/fga/resources/save',
    mappableSchema: '/v1/mgmt/fga/mappable/schema',
    mappableResources: '/v1/mgmt/fga/mappable/resources',
  },
  descoper: {
    create: '/v1/mgmt/descoper',
    update: '/v1/mgmt/descoper',
    get: '/v1/mgmt/descoper',
    delete: '/v1/mgmt/descoper',
    list: '/v1/mgmt/descoper/list',
  },
  managementKey: {
    create: '/v1/mgmt/managementkey',
    update: '/v1/mgmt/managementkey',
    load: '/v1/mgmt/managementkey',
    delete: '/v1/mgmt/managementkey/delete',
    search: '/v1/mgmt/managementkey/search',
  },
  license: {
    get: '/v1/mgmt/license',
  },
  engine: {
    create: '/v1/mgmt/engine/create',
    update: '/v1/mgmt/engine/update',
    delete: '/v1/mgmt/engine/delete',
    load: '/v1/mgmt/engine/load',
    loadAll: '/v1/mgmt/engines/load',
    rotate: '/v1/mgmt/engine/rotate',
  },
  analytics: {
    search: '/v1/mgmt/analytics/search',
  },
  list: {
    create: '/v1/mgmt/list',
    update: '/v1/mgmt/list/update',
    delete: '/v1/mgmt/list/delete',
    load: '/v1/mgmt/list',
    loadByName: '/v1/mgmt/list/name',
    loadAll: '/v1/mgmt/list/all',
    import: '/v1/mgmt/list/import',
    addIPs: '/v1/mgmt/list/ip/add',
    removeIPs: '/v1/mgmt/list/ip/remove',
    checkIP: '/v1/mgmt/list/ip/check',
    addTexts: '/v1/mgmt/list/text/add',
    removeTexts: '/v1/mgmt/list/text/remove',
    checkText: '/v1/mgmt/list/text/check',
    clear: '/v1/mgmt/list/clear',
  },
  jwtTemplate: {
    create: '/v1/mgmt/jwt/templates/create',
    update: '/v1/mgmt/jwt/templates/update',
    delete: '/v1/mgmt/jwt/templates/delete',
    list: '/v1/mgmt/jwt/templates/list',
    load: '/v1/mgmt/jwt/templates/load',
    validate: '/v1/mgmt/jwt/templates/validate',
    libraryList: '/v1/mgmt/jwt/templates/library/list',
    libraryLoad: '/v1/mgmt/jwt/templates/library/load',
    libraryApply: '/v1/mgmt/jwt/templates/library/apply',
  },
  scopeClaimMapping: {
    get: '/v1/mgmt/scopeClaimMapping/get',
    set: '/v1/mgmt/scopeClaimMapping/set',
    delete: '/v1/mgmt/scopeClaimMapping/delete',
  },
};
